var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useTranslation } from "react-i18next";
import { AppBar, Box, Container, CssBaseline, IconButton, Toolbar, Tooltip, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Brightness4, Brightness7 } from "@material-ui/icons";
import { locales } from "frontend/src/domain/localization/i18n";
import { LanguageSwitcher } from "frontend/src/domain/localization";
import { Logo } from "frontend/src/ui/logo";
import { useThemeMode } from "frontend/src/shared/theme-mode";
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        root: {
            position: "relative",
            minHeight: "100vh",
            color: theme.palette.type === "dark" ? "#fff" : "#2f343b",
            backgroundColor: theme.palette.type === "dark" ? "#101418" : "#eef3f5",
            overflow: "hidden",
            "&:before": {
                content: '""',
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundImage: theme.palette.type === "dark"
                    ? "url('/images/client-dashboard-bg.jpg')"
                    : "url('/images/client-dashboard-bg-light.jpg')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                opacity: theme.palette.type === "dark" ? 0.72 : 0.94,
                transform: "scale(1.03)",
                pointerEvents: "none",
            },
            "&:after": {
                content: '""',
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                background: theme.palette.type === "dark"
                    ? "rgba(5, 9, 14, 0.24)"
                    : "rgba(14, 27, 42, 0.12)",
                pointerEvents: "none",
            },
            "& > *": {
                position: "relative",
                zIndex: 1,
            },
        },
        appBar: {
            color: theme.palette.type === "dark" ? "#fff" : "#2f343b",
            backgroundColor: "rgba(15, 21, 31, 0.26)",
            backdropFilter: "blur(22px) saturate(145%)",
            WebkitBackdropFilter: "blur(22px) saturate(145%)",
            boxShadow: "0 16px 40px rgba(0, 0, 0, 0.12)",
            borderBottom: "1px solid rgba(255, 255, 255, 0.14)",
        },
        toolbar: __assign(__assign({}, theme.mixins.toolbar), { minHeight: 64 }),
        logo: (_a = {
                display: "flex",
                alignItems: "center",
                width: 190,
                "& path:not([fill])": {
                    fill: theme.palette.type === "dark" ? "#fff" : "#111",
                }
            },
            _a[theme.breakpoints.down("xs")] = {
                width: 150,
            },
            _a),
        actions: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
            marginLeft: "auto",
        },
        container: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "calc(100vh - 64px)",
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
        },
    });
});
export var GuestUserLayout = function (_a) {
    var children = _a.children;
    var classes = useStyles();
    var ready = useTranslation(locales.namespaces.guest).ready;
    var _b = useThemeMode(), mode = _b.mode, toggleMode = _b.toggleMode;
    if (!ready)
        return null;
    return (React.createElement(Box, { className: classes.root },
        React.createElement(CssBaseline, null),
        React.createElement(AppBar, { position: "static", color: "inherit", className: classes.appBar },
            React.createElement(Toolbar, { className: classes.toolbar },
                React.createElement(Box, { className: classes.logo },
                    React.createElement(Logo, { width: "100%", height: "auto" })),
                React.createElement(Box, { className: classes.actions },
                    React.createElement(Tooltip, { title: mode === "dark" ? "Включить светлый режим" : "Включить темный режим" },
                        React.createElement(IconButton, { onClick: toggleMode, color: "inherit" }, mode === "dark" ? React.createElement(Brightness7, null) : React.createElement(Brightness4, null))),
                    React.createElement(LanguageSwitcher, null)))),
        React.createElement(Container, { component: "main", maxWidth: "xs", className: classes.container },
            React.createElement(Box, { width: "100%" }, children))));
};
